import { DmpSexEnum } from "./dmp-hl-find-patient-params.interface";
import { DmpHlFindPatientResponseSIns } from "./dmp-hl-find-patient-response.interface";

export interface DmpHlGetDirectAuthentificationDmpStatus {
  ExistingTestAnswer: {
    AdminData: {
      Ins: DmpHlFindPatientResponseSIns;
      s_birthday: Date;
      s_insC: string;
      s_patientGivenName: string;
      s_patientName: string;
      s_patientBirthName: string;
      s_patientFirstBirthGiven: string
    },
    i_dmpStatus: DmpStatusEnum;
    i_sex: DmpSexEnum;
    i_userAuthorization: DmpUserAuthorizationEnum;
    i_webAccessIsOpen: boolean;
    i_ensRelatedDmp: boolean;
    s_closingDate?: Date;
    s_closingMessage?: string;
  };
  i_treatingPhysician: boolean;
  s_mail: string;
  s_mobilePhone: string;
  s_status: string;
}

export enum DmpStatusEnum {
  'DMP existant' = 1,
  'DMP fermé' = 2,
  'DMP inexistant' = 3,
  'Erreur' = 4
}

export enum DmpUserAuthorizationEnum {
  'AuthorizationError' = 1,
  'AuthorizationExist' = 2,
  'AuthorizationExpired' = 3,
  'AuthorizationDenied' = 4,
  'NoAuthorization' = 5
}
